(function () {
    function injectStyles() {
        const el = document.querySelector("vdslz-container");

        if (!el || !el.shadowRoot) {
            return false;
        }

        if (el.shadowRoot.getElementById("custom-vdslz-style")) {
            return true;
        }

        const style = document.createElement("style");
        style.id = "custom-vdslz-style";
        style.textContent = `
            .vdslz-heading p {
                font-family:var(--font-heading-family);
                font-size: 50px !important;
                font-weight:500 !important;
                line-height: 1.2 !important;
                margin: 0;
                padding: 50px 0px 0;
            }
            .vdslz-heading strong{
                color:#c2673c !important;
            }
            .vdslz-container.svelte-1bojhsa {
                margin: 0 !important;
            }
            @media screen and (max-width: 768px) {
                .vdslz-heading p {
                    font-size: 30px !important;
                    padding: 30px 0px 0;
                }
            }
        `;

        el.shadowRoot.appendChild(style);
        console.log("Videoselz styles injected");
        return true;
    }

    const timer = setInterval(() => {
        if (injectStyles()) {
            clearInterval(timer);
        }
    }, 500);
})();






(function () {

  const AUTOPLAY_SPEED = 4000;

  function initJudgeMeCarousel() {

    const track = document.querySelector(
      '#jdgm-masonry-grid-id'
    );

    if (!track) return;

    const items = track.querySelectorAll(
      '.jdgm-masonry-grid__masonry-item'
    );

    if (!items.length) return;

    let wrapper = track.parentElement;

    /* =========================================
       CREATE WRAPPER
    ========================================= */

    if (!wrapper.classList.contains('jdgm-carousel-wrapper')) {

      const newWrapper = document.createElement('div');

      newWrapper.className = 'jdgm-carousel-wrapper';

      track.parentNode.insertBefore(
        newWrapper,
        track
      );

      newWrapper.appendChild(track);

      wrapper = newWrapper;
    }


    /* =========================================
       CREATE ARROWS ONLY ONCE
    ========================================= */

    if (!wrapper.querySelector('.jdgm-carousel-prev')) {

      const prev = document.createElement('button');

      prev.type = 'button';

      prev.className =
        'jdgm-carousel-arrow jdgm-carousel-prev';

      prev.setAttribute(
        'aria-label',
        'Previous reviews'
      );

      prev.innerHTML = '&#10094;';


      const next = document.createElement('button');

      next.type = 'button';

      next.className =
        'jdgm-carousel-arrow jdgm-carousel-next';

      next.setAttribute(
        'aria-label',
        'Next reviews'
      );

      next.innerHTML = '&#10095;';


      wrapper.appendChild(prev);
      wrapper.appendChild(next);


      prev.addEventListener(
        'click',
        function () {

          moveCarousel(
            track,
            -1
          );

        }
      );


      next.addEventListener(
        'click',
        function () {

          moveCarousel(
            track,
            1
          );

        }
      );
    }


    /* =========================================
       SAME HEIGHT
    ========================================= */

    setEqualHeight(track);


    /* =========================================
       AUTOPLAY
    ========================================= */

    if (!wrapper._judgeMeAutoplayStarted) {

      startAutoplay(
        track,
        wrapper
      );

      wrapper._judgeMeAutoplayStarted =
        true;
    }


    /* =========================================
       PAUSE ON HOVER
    ========================================= */

    if (!wrapper._judgeMeHoverEvents) {

      wrapper.addEventListener(
        'mouseenter',
        function () {
          pauseAutoplay(wrapper);
        }
      );


      wrapper.addEventListener(
        'mouseleave',
        function () {
          startAutoplay(
            track,
            wrapper
          );
        }
      );


      /* Pause while touching/swiping */
      wrapper.addEventListener(
        'touchstart',
        function () {
          pauseAutoplay(wrapper);
        },
        { passive: true }
      );


      wrapper.addEventListener(
        'touchend',
        function () {
          startAutoplay(
            track,
            wrapper
          );
        },
        { passive: true }
      );


      wrapper._judgeMeHoverEvents =
        true;
    }
  }


  /* =========================================
     MOVE CAROUSEL
  ========================================= */

  function moveCarousel(track, direction) {

  const item = track.querySelector(
    '.jdgm-masonry-grid__masonry-item'
  );

  if (!item) return;

  const gap =
    parseFloat(getComputedStyle(track).gap) || 0;

  const itemWidth =
    item.getBoundingClientRect().width;

  /* Move exactly ONE card */
  const moveAmount = itemWidth + gap;

  const maxScroll =
    track.scrollWidth - track.clientWidth;

  let newPosition =
    track.scrollLeft + (moveAmount * direction);

  /* Next → loop to beginning */
  if (
    direction > 0 &&
    newPosition >= maxScroll - 5
  ) {
    newPosition = 0;
  }

  /* Previous → loop to last card */
  if (
    direction < 0 &&
    newPosition <= 0
  ) {
    newPosition = maxScroll;
  }

  track.scrollTo({
    left: newPosition,
    behavior: 'smooth'
  });
}


  /* =========================================
     VISIBLE CARDS
  ========================================= */

  function getVisibleCards() {

    const width =
      window.innerWidth;


    if (width <= 640) {
      return 1;
    }


    if (width <= 990) {
      return 2;
    }


    return 3;
  }


  /* =========================================
     EQUAL HEIGHT
  ========================================= */

  function setEqualHeight(track) {

    const cards =
      track.querySelectorAll(
        '.jdgm-review-card'
      );


    if (!cards.length) return;


    /* Reset first */

    cards.forEach(function (card) {

      card.style.height = 'auto';

    });


    let maxHeight = 0;


    /* Find tallest card */

    cards.forEach(function (card) {

      const height =
        card.getBoundingClientRect().height;


      if (height > maxHeight) {

        maxHeight = height;

      }

    });


    /* Apply tallest height */

    cards.forEach(function (card) {

      card.style.height =
        maxHeight + 'px';

    });
  }


  /* =========================================
     AUTOPLAY
  ========================================= */

  function startAutoplay(
    track,
    wrapper
  ) {

    pauseAutoplay(wrapper);


    wrapper._judgeMeAutoplay =
      setInterval(
        function () {

          moveCarousel(
            track,
            1
          );

        },
        AUTOPLAY_SPEED
      );
  }


  /* =========================================
     PAUSE AUTOPLAY
  ========================================= */

  function pauseAutoplay(wrapper) {

    if (
      wrapper &&
      wrapper._judgeMeAutoplay
    ) {

      clearInterval(
        wrapper._judgeMeAutoplay
      );

      wrapper._judgeMeAutoplay =
        null;
    }
  }


  /* =========================================
     INITIAL LOAD
  ========================================= */

  function waitForJudgeMe() {

    const track =
      document.querySelector(
        '#jdgm-masonry-grid-id'
      );


    if (track) {

      initJudgeMeCarousel();

    } else {

      setTimeout(
        waitForJudgeMe,
        500
      );
    }
  }


  waitForJudgeMe();


  /* =========================================
     JUDGEME DYNAMIC CONTENT
  ========================================= */

  const observer =
    new MutationObserver(
      function () {

        const track =
          document.querySelector(
            '#jdgm-masonry-grid-id'
          );


        if (!track) return;


        setTimeout(
          function () {

            setEqualHeight(track);

          },
          100
        );

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* =========================================
     RESIZE
  ========================================= */

  let resizeTimer;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(resizeTimer);


      resizeTimer =
        setTimeout(
          function () {

            const track =
              document.querySelector(
                '#jdgm-masonry-grid-id'
              );


            if (track) {

              setEqualHeight(track);

            }

          },
          200
        );
    }
  );

})();